<template>
	<v-card outlined class = "pa-0 ma-1">
		<v-row
			no-gutters
			dense
		>
			<template v-for = "(item_content, key_content, idx_content) of informations">
				
				 <v-col
					:key = "idx_content"
					:md  = "key_content.includes('images') || key_content.includes('title_sub_content') ? 12 : 6"					

				>	
				 	<v-item-group
				 		multiple
				 		v-if    = "key_content.includes('images')" 
						:class 	= "'overflow-y-auto'"

				 	>
				 	
						<v-container 
							fluid 
							:style = "{height : '25p0px'}"
							class  = "pa-0"    												
						>
						<!--  overflow-y-auto  -->
							<v-row 
								v-if  = "key_content.includes('images')" 
								no-gutters
							>

								<template 										
									v-for = " (item_img, idx_img) of item_content"
								>
								<!--  -->
									<v-col
										:cols  = "item_img && item_img.col ? item_img.col : 
												item_content.length == 1 ? 12 : 
												item_img.is_segment ? 12 : 6"
										:key   = "idx_img"
										

									>
										<v-item v-slot = "{ active, toggle }"
											
										>
										
										<!-- actions('select_imagen', item_img) -->
											<v-card 
												outlined 
												v-if 	= "item_img.img"
												@click 	= "item_img.is_selection ? toggle() : redirectImg(item_img.img)"
												:color 	= "active && item_img.is_selection ? 'primary' : ''"
												:class  = "item_img.class"
												:height = "item_img.height_card"
											>											
												<v-card-title
													class  = "caption pa-0 secondary"
													v-show = "item_img.title"
												>
													<span>
														{{ item_img.title }}
													</span>
													
												</v-card-title>
												
												<div 
													:id     = "'content_modal' + idx_img  + ref_to_component"
													:style  = "`position: relative; width:100%; height: ${  item_img.title ? '100%' : item_img.height ? item_img.height  : setting_img.height + 'px'}; aspect-ratio: 1.8;`"
												>												
													<img 		
															
															

														:id 		 = "'img_modal' + idx_img  + ref_to_component" 	
														:src 		 = "$Helper.check_img(item_img.img, $URL)"
														class 		 = "mb-0 pa-0"		
														:style 		 = "`
																		position 	: absolute;
																		width 		: 100%;
																	   	height 		: 100%;
																	   	object-fit 	: ${ item_img.fit ? item_img.fit :  'fill' };
																	   	z-index 	: 1,

																	   `"	
														@error  	  = "item_img.img = '/img/no_img_found.png'"
													/>
													
													<canvas
														@ready 		= "drawBBox(item_img.bbox, idx_img)"
														:id 		= "'draw_modal' + idx_img + ref_to_component"
														:style 		= "`position : relative; 
																		width : ${ item_img.title ? '100%' : '100%'};
																		height : ${ item_img.height ? item_img.height  : '100%'};
																		z-index : ${idx_img + 1};
																	  `"
													></canvas>
													
												</div>
												
												<span
												class = "pa-0 caption"
													v-if = "item_img.probability"
												>
													{{ item_img.probability }}
												</span>
											</v-card>
										</v-item>
									</v-col>

								</template>	
							</v-row>
						</v-container>
					</v-item-group>

					<!-- content  -->
					<span
						v-if 	= "key_content.includes('title_sub_content') && !key_content.includes('images') && key_content != 'toolbar' && key_content != 'fields'"
									
					>
						<span
							class  = "font-weight-medium primary--text caption"
						>													
							{{ item_content }}
						</span>

						<v-divider																										
							class = "pb-1 ma-0"
						></v-divider>
					</span>

					<v-card 
						outlined
						v-if    = "!key_content.includes('images') && key_content != 'toolbar' && key_content != 'fields' && !key_content.includes('title_sub_content')" 
						:height = "item_content && item_content.height ? item_content.height :  '100%'"
						

					>
						<v-card-title
							class = "pa-0 pl-1 secondary body-2 white--text"
						>
							{{ $ml.get(key_content) || key_content  }}
						</v-card-title>
						<v-card-text 
							:class = " key_content == 'plate_chars' ? 'pa-1 pl-1 caption' :'pa-0 pl-1 caption'"
						>	
							<span v-show = " key_content != 'segment'">	
								<span v-show = " key_content != 'plate_chars'">
									{{ item_content }}									
								</span>			
								<v-chip
									label
									v-show = " key_content == 'plate_chars'"
									color  = "secondary"
									class  = "secondary"
									
								>															
									<strong >
										{{ item_content }}	
									</strong>
								</v-chip>
							</span>													
							<img 			
								v-show 		 = "key_content == 'segment'" 
								v-if 		 = "item_content && key_content == 'segment'"
								:id 		 = "'img_modal_content' + key_content" 	
								:src 		 = "$Helper.check_img(item_content.img, $URL)"
								@error  	 = "item_content.img = '/img/no_img_found.png'"
								@click 		 = "redirectImg(item_content.img)"
								class 		 = "mb-1"		
								:style 		 = "`
												position 	: absolute;
												width 		: 95%;
											   	height 		: 75%;
											   	object-fit 	: ${ item_content && item_content.fit ? item_content.fit :  'contain' };
											   	
											   `"						
								:aspect-ratio = "0"					
							/>
						</v-card-text>
					</v-card>
				</v-col> 
			</template>
		</v-row>
	</v-card>
</template>
<script type="text/javascript">
	export default{
		name 	: "videoInformation",
		props 	: [ "info_to_component"],
		data 	: (vm) => ({
			informations : null,
			ref_to_component : "basicInformation",
			setting_img 	: {
				height  : 235,				
			}, 
		}), // data
		created(){
			if (this.info_to_component) {
				this.renderInfo(this.info_to_component);
			}
		}, // created
		watch: {
			info_to_component: function(val){
				if (val) {
					this.renderInfo(val);
				}
			}
		}, // watch
		methods : {
			renderInfo(item){
				if (item) {					
					console.log("load basic informations ", item)
					this.informations  = {...item};
				}
			}, // renderInfo

			redirectImg(val){				
				window.open(this.$Helper.check_img(val, this.$URL),'_blank');
			}, // redirect img

			drawBBox(bbox, idx_bbx){
				let vm = this;
				let items
				if (bbox) {
				 	const timer = setTimeout(()=>{				        
				        let content           = document.getElementById('content_modal' + idx_bbx  + vm.ref_to_component);
				        let img               = document.getElementById('img_modal' + idx_bbx   + vm.ref_to_component);
				       	let roi  			  = document.getElementById('draw_modal' + idx_bbx   + vm.ref_to_component);
				        let context_roi       = null;
				        if (!content && !img  && !roi){
				        	content           = document.getElementById('content_snack' + idx_bbx  + vm.ref_to_component);
					        img               = document.getElementById('img_snack' + idx_bbx   + vm.ref_to_component);
					       	roi  			  = document.getElementById('draw_snack' + idx_bbx   + vm.ref_to_component);				        	
				        }

				        if (roi && roi.getContext('2d')) {
				        	context_roi        = roi.getContext('2d');

				        	let less = 0;
				            roi.style.height = img.style.height = content.style.height = content.getBoundingClientRect().height + 'px'; 
				       		
				       		let current_width  = roi.width    = img.getBoundingClientRect().width,  
				            	current_height = roi.height   = img.getBoundingClientRect().height;

				            context_roi.clearRect(0, 0, current_width, current_height );

				            if (arr_bbx && typeof arr_bbx == 'string') {
				            	try{
				            		arr_bbx = JSON.parse(arr_bbx)
				            		if (arr_bbx && typeof arr_bbx == 'string') {
				            			arr_bbx = JSON.parse(arr_bbx);
				            		}
				            	}catch(er){
				            		console.log("Not possible convert bbox to object ", er);
				            	}
				            }

				            if (bbox && bbox.length > 0) {
				            	// console.log("BBOX : ***************** ", arr_bbx.bbox)
				            	bbox.forEach( element => {
				            		if (element) {


				            			let color_set = '';
				            			let temp_tag  = element.tag || tag_1;
						                if (vm.draw_colors && vm.draw_colors.length > 0) {
						                  const find_color = vm.draw_colors.some( (tag_color => {
						                    if (tag_color.tag == temp_tag) {
						                      color_set = tag_color.color;
						                      return true
						                    }
						                  })) 
						                }
						                if(!color_set){
						            		let o    = Math.round, r = Math.random, s = 255;
							                let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
							                let num1 = o(r()*s)
							                let num2 = o(r()*s)
							                let num3 = o(r()*s)
						                	
						                	color_set	= 'rgba('+num1+','+num2+','+num3+',0.5)';

						                }

						                // color stroke / fill 

						                context_roi.strokeStyle = color_set;
						                // width line
										
						                context_roi.lineWidth   = vm.line_width || 2;
										
						                let b_box = {
						                	x : element.bbox && element.bbox.x ? element.bbox.x : element.x,
											y : element.bbox && element.bbox.y ? element.bbox.y : element.y,
											w : element.bbox && element.bbox.w ? element.bbox.w : element.w,
											h : element.bbox && element.bbox.h ? element.bbox.h : element.h,
										};

						                let fx = b_box.x *  parseInt(current_width) ;
						                let fy = b_box.y *  parseInt(current_height);
						                let w  = b_box.w *  parseInt(current_width);
						                let h  = b_box.h *  parseInt(current_height);

						                fx = Math.abs(fx)
        								fy = Math.abs(fy)

						             
						                context_roi.strokeRect(fx, fy, w, h); // fill

						                
						                context_roi.font      = "12px Georgia";
						                context_roi.fillStyle = "white";//"rgba(96,96,96)"; // 0,0,0,1 
						                context_roi.fillText(temp_tag, fx + 20, fy + 10);//(element.bbox.x*factorx)+20, (element.bbox.y*factory)+20);
						                if (vm.type == 'alert') {

						                }
					              	}  
				            	}); // forEach
				            }else{
				            	console.log("BBOX Not found : ***************** "/*, arr_bbx.bbox*/);
				            }
				            // clearTimeout(time_tick);
				        // }, 100)
				        }else{
				        	console.warn("Context not compatible with 2D ",  idx_bbx);
				        }
				        clearTimeout(timer);
			       	}, 350) // 2
				} // bbox
			},
		}, // methods
		beforeDestroy() {
			// Limpieza de posibles timers y canvas
			// Si se usaran timers globales, guardarlos en this y limpiarlos aquí
			// Limpieza de canvas
			const elements = document.querySelectorAll('[id^="draw_modal"]');
			elements.forEach(el => {
				const ctx = el.getContext && el.getContext('2d');
				if (ctx) ctx.clearRect(0, 0, el.width, el.height);
			});
		},
	}
</script>